import React from 'react';
import Highcharts from 'highcharts';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css';
import './assets/sass/fonts/fonts.scss';
import './App.scss';

import { globalChartConfig } from './core/config/chart';
import PrivateContent from './containers/PrivateContent/PrivateContent';
import Login from './components/Login/Login';
import PublicContent from './containers/PublicContent/PublicContent';
import { PATH_PREFIX } from './core/config/config';
import reflowChartsBeforePrint from './core/helpers/reflowChartsBeforePrint';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

Highcharts.setOptions({ ...globalChartConfig });

reflowChartsBeforePrint(Highcharts);

function App(): JSX.Element {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path={`${PATH_PREFIX}/`} exact>
            <PublicContent />
          </Route>
          <Route path={`${PATH_PREFIX}/admin`}>
            <PrivateContent />
          </Route>
          <Route path={`${PATH_PREFIX}/login`}>
            <Login />
          </Route>
        </Switch>
      </Router>
      <ScrollToTop />
    </div>
  );
}

export default App;
